<template>
  <header
    class="d-flex flex-column flex-md-row align-items-center p-2 px-md-4 bg-white shadow-sm"
  >
    <h1 class="my-0 mr-md-auto">
      <a href="/storymap" class="d-flex align-items-center">
        <img src="@/assets/logo.png" class="img-logo" alt="新竹縣災害歷史影像資料庫" />
        新竹縣災害歷史影像資料庫
      </a>
    </h1>
    <nav class="my-2 my-md-0 mr-md-3">
      <router-link to="/" class="m-2 text-dark"
        >災害歷史影像資料庫</router-link
      >
      <router-link to="/map" class="m-2 text-dark"
        >影像地圖</router-link
      >
      <router-link to="/collection" class="m-2 text-dark"
        >相簿募集</router-link
      >
      <router-link to="/about" class="m-2 text-dark"
        >關於網站</router-link
      >
    </nav>
  </header>
</template>

<script>
export default {}
</script>
